// The one setting that picks the map: the import below. The client build bakes this JSON into the bundle
// and the server loads the same file, so both run the same map; the hash in `hello` catches a stale client.
import raw from '../../../maps/tworivers.json';
import { validateMap } from './schema.js';
import { hashMap } from './hash.js';

/** Validated at import: an invalid map stops the server (and the build) before anything else runs. */
export const ACTIVE_MAP = validateMap(raw, 'maps/tworivers.json');
export const MAP_HASH = hashMap(ACTIVE_MAP);
